import React, { useState, useEffect } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import Input from "reactstrap/lib/Input";
import Table from "reactstrap/lib/Table";
import Button from "reactstrap/lib/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FindUserInfo from "../../components/UserManagement/FindUserInfo";
import AddUserAPLLicense from "../../components/UserManagement/AddUserAPLLicense";
import MoveUser from "../../components/UserManagement/MoveUser";
import DeleteResults from "../../components/UserManagement/DeleteResults";
import DeleteUser from "../../components/UserManagement/DeleteUser";
import RestoreDeleteStudentWithNoCLass from "../../components/UserManagement/RestoreDeleteStudentWithNoCLass";
import RestoreDeleteStudentWithNoCLassAndNoLicense from "../../components/UserManagement/RestoreDeleteStudentWithNoCLassAndNoLicense";
import CleanLicense from "../../components/UserManagement/CleanLicense";
import { GetAdminUsers } from "../../actions/adminQueries";
import axios from "../../services/api/api";
import ConfirmDialog from "../../components/Modal/ConfirmDialog";
import CreateOrUpdateUserModal from "../../components/Modal/CreateOrUpdateUserModal";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [showAddOrUpdateUserDialog, setShowAddOrUpdateUserDialog] = useState(false);
  const [userToUpdate, setUserToUpdate] = useState(null);

  const adminUsers = GetAdminUsers();

  useEffect(() => {
    if (adminUsers.data) {
      setUsers(adminUsers.data);
    }
  }, [adminUsers.data]);

  const toggleAddOrUpdateUserDialog = (user) => {
    setUserToUpdate(user);
    setShowAddOrUpdateUserDialog((prev) => !prev);
  };

  const deleteUser = () => {
    axios
      .put(`/admin/deleteuser/${userToDelete.id}`)
      .then(() => {
        adminUsers.refetch();
        dismissConfirmDeleteDialog();
      })
      .catch((err) => {
        console.warn("det gick inte att ta bort användaren", err);
      });
  };

  const dismissConfirmDeleteDialog = () => {
    setShowConfirmDeleteDialog(false);
    setUserToDelete(null);
  };

  const filterByQuery = (event) => {
    let query = event.target.value.trim().toLowerCase();
    if (query) {
      let filteredUsers = (adminUsers.data || []).filter((user) => {
        return (
          user.name.toLowerCase().indexOf(query) >= 0 ||
          user.email.toLowerCase().indexOf(query) >= 0
        );
      });
      setUsers(filteredUsers);
    } else {
      setUsers(adminUsers.data || []);
    }
  };

  return (
    <div>
      <FindUserInfo />
      <DeleteUser />
      <RestoreDeleteStudentWithNoCLass />
      <RestoreDeleteStudentWithNoCLassAndNoLicense />
      <MoveUser />
      <DeleteResults />
      <CleanLicense />
      <AddUserAPLLicense />
      <div className="container-fluid admin-container">
        <Row className="search-row">
          <Col className="col-3">
            <Input
              className="search-input"
              placeholder="Sök admin-användare"
              onChange={(event) => filterByQuery(event)}
            />
          </Col>
          <Col className="offset-7 col-2">
            <Button
              color="primary"
              outline
              className="pull-right fa fa-plus"
              onClick={() => {
                toggleAddOrUpdateUserDialog(null);
              }}
            >
              <FontAwesomeIcon icon="plus" />
            </Button>
          </Col>
        </Row>
        <Row>
          <Table hover responsive>
            <thead>
              <tr>
                <th>Användarnamn</th>
                <th>E-post</th>
                <th>Roll</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={index}>
                  <td className={user.deleted ? "text-deletion" : ""}>
                    {user.name}
                  </td>
                  <td className={user.deleted ? "text-deletion" : ""}>
                    {user.email}
                  </td>
                  <td className={user.deleted ? "text-deletion" : ""}>
                    {user.role}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Row>
      </div>

      <ConfirmDialog
        isOpen={showConfirmDeleteDialog}
        title="Ta bort användare"
        message={`Är du säker på att du vill ta bort användaren ${
          userToDelete ? userToDelete.name : ""
        }?`}
        toggle={dismissConfirmDeleteDialog}
        onProceed={deleteUser}
        danger={true}
      />

      <CreateOrUpdateUserModal
        toggle={toggleAddOrUpdateUserDialog}
        show={showAddOrUpdateUserDialog}
        user={userToUpdate}
        updateUsers={() => adminUsers.refetch()}
      />
    </div>
  );
}
